import React from "react";
import "./style.css";
import localization from "../../../../data/config";
import { PRODUCT_SAMPLE_AND_BUY_URL } from '../../../../constants/config/parts';
import * as PARAMETERS from '../../../../constants/config/parameters';

/**
 * @name TableData
 * @function
 * @description Displays Table data values
 * @returns {JSX}
 * @param {*} props
 */
const TableData = (props) => {
  const NO_VALUE = "-";
  if (!props.format) return null;

  let show =
    props.displayValue && props.displayValue.length > 0
      ? props.displayValue
      : NO_VALUE;

      const availabilityValue = Number(props.displayValue) > 0 ? props.displayValue : <a href={ PRODUCT_SAMPLE_AND_BUY_URL.replace( '{generic}', props.generic ) } target="_blank" rel="noopener noreferrer">{localization.checkDistributor}</a>

  return (
    <td
      className={`${props.format}__tabledata table__content ${
        props.parameter === PARAMETERS.INVENTORY
          ? "header__titles--availability"
          : "" 
      }`}
      data-parameter={props.parameter}
    >
      {props.parameter === PARAMETERS.INVENTORY ? availabilityValue : props.parameter === PARAMETERS.STATUS ? (
        <div className="pst__product__status">
          <div className="header__titles__subheader" dangerouslySetInnerHTML={{ __html: show }} />
        </div>
      ) : (
        <span dangerouslySetInnerHTML={{ __html: show }} />
      )}
      
    </td>
  );
};

export default TableData;
